import { CurrentFlow } from 'enums/CurrentFlow';
import { useSelector } from 'react-redux';
import { getApplicationStep } from 'selectors/getApplicationStep';

const useCurrentFlow = () => {
  const { currentFlow } = useSelector(getApplicationStep);

  return {
    currentFlow,
    isCardFlow: currentFlow === CurrentFlow.Card,
    isDebtConsolidationFlow: currentFlow === CurrentFlow.DebtConsolidation,
    isFinancialCheckupFlow: currentFlow === CurrentFlow.FinancialCheckup,
    isAICoachFlow: currentFlow === CurrentFlow.AICoach,
    isStudentLoanForgivenessFlow: currentFlow === CurrentFlow.StudentLoanForgiveness,
  };
};

export default useCurrentFlow;
